module.exports = __webpack_public_path__ + "static/attrasafe-79f6594306c4bffdbd4fa543cc6ffa43.png";